import { UtilsService } from '../../../@core/utils/utils.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { KPI } from '../../../@core/api';
import { SpreadsheetColumnsInitiativesService, YearsService } from '../../../@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridInitiativeComponent } from '../ag-grid-initiative/ag-grid-initiative.component';
import { TableFilterComponent } from '../table-filter/table-filter.component';
import { PreDownloadDialogComponent } from '../pre-download-dialog/pre-download-dialog.component';

import { NbCardModule, NbButtonModule, NbTooltipModule, NbDialogService } from '@nebular/theme';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-initiatives-spreadsheet',
    styleUrls: ['./initiatives-spreadsheet.component.scss'],
    templateUrl: './initiatives-spreadsheet.component.html',
    standalone: true,
    imports: [
    FontAwesomeModule,
    NbCardModule,
    NbButtonModule,
    NbTooltipModule,
    TableFilterComponent,
    AgGridInitiativeComponent,
    TranslateModule
],
})
export class InitiativesSpreadsheetComponent implements OnInit, OnDestroy {

  @ViewChild(AgGridInitiativeComponent) grid!: AgGridInitiativeComponent;

  @Input() public inputFilters: { [key: string]: string | boolean | number };
  @Input() public inputColumns: string[];
  @Input() public inputScenario: KPI.InvestmentScenario;
  @Input() public minimizedView: boolean = false;
  @Input() public showScenarii: boolean = false;
  @Input() public project: KPI.Project;
  @Input() public isFidjiAct: boolean = true;

  private subscriptions: Subscription[] = [];
  public filtersNb: number = 0;

  public startYear$ = this.yearsService.startYear$;
  public totalInitiatives: number = 0;
  public co2Savings: number = 0;
  public kwhSavings: string = '0';


  constructor(
    private utilsService: UtilsService,
    private yearsService: YearsService,
    private initiativeService: SpreadsheetColumnsInitiativesService,
    private dialogService: NbDialogService,
  ) { }

  public ngOnInit(): void { }

  public savingsSummaryUpdated(savingsSummary: KPI.SavingsSummary) {
    this.totalInitiatives = savingsSummary.totalInitiatives || 0;
    this.co2Savings = this.utilsService.round2dec(savingsSummary.co2Savings / 1000, 1) || 0;
    this.kwhSavings = savingsSummary.savings ? this.utilsService.formateNumber(savingsSummary.savings) : '0';
  }

  public exportInitiative(): void {
    const columns = this.grid.gridApi?.getAllDisplayedColumns()
      .map(col => {
        const colDef = col.getUserProvidedColDef();
        const { hide, ...colDefWithoutHide } = colDef;
        return colDefWithoutHide;
      });
    this.initiativeService.preExportInitiatives(columns).subscribe((downloadOptions) => {
      this.dialogService.open(PreDownloadDialogComponent, {
        closeOnBackdropClick: false,
        context: { downloadOptions, columns, reportType: 'ini' },
      });
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
